import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function AdminGuard({ children }) {
  const { user, isAdmin } = useAuth();
  if (user && !isAdmin) return <Navigate to="/" replace />;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
